import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import Image from 'next/image';
import _ from 'lodash';
import isEmpty from 'lodash/isEmpty';
import moment from 'moment';

import { withTranslation } from 'language/i18n';
import { getObjectByLanguage } from 'language/helpers';

const MachineInformationSide = ({ t, machine, timeLeft }) => {
  const handleHeadColor = useMemo(() => {
    if (timeLeft?.days > 1) {
      return 'im-bidding-head--green';
    }
    return 'im-bidding-head--red';
  }, [timeLeft]);

  return (
    <div className="col-15 col-sm mb-2 mb-sm-0 d-flex flex-column">
      {
        !isEmpty(timeLeft)
        && (
          <div className="im-box im-box--white im-box--border-radius im-box--padding-0">
            <div className={`im-bidding-head ${handleHeadColor}`}>
              <div className="row align-items-center w-100">
                <div className="col text-right">
                  <div className="fw-700">Açık artırmanın bitmesine</div>
                  <div className="fw-400 fs-13">{`(${moment(machine.event.endDate).format('DD MMMM, HH:mm')})`}</div>
                </div>
                <div className="col">
                  {
                    _.result(timeLeft, 'days') !== undefined && timeLeft.days > 0
                    && (
                      <>
                        <span className="fs-25 fw-700 ml-1 mr-1">{timeLeft.days}</span>
                        <span className="fs-15">{t('day')}</span>
                      </>
                    )

                  }

                  {
                    _.result(timeLeft, 'hours') !== undefined
                    && (
                      <>
                        <span className="fs-25 fw-700 ml-1 mr-1">{timeLeft.hours}</span>
                        <span className="fs-15">{t('hr')}</span>
                      </>
                    )

                  }
                  {
                    _.result(timeLeft, 'minutes') !== undefined
                    && (
                      <>
                        <span className="fs-25 fw-700 ml-1 mr-1">{timeLeft.minutes}</span>
                        <span className="fs-15">{t('min')}</span>
                      </>
                    )

                  }
                  {
                    _.result(timeLeft, 'seconds') !== undefined
                    && (
                      <>
                        <span className="fs-25 fw-700 ml-1 mr-1">{timeLeft.seconds}</span>
                        <span className="fs-15">{t('sec')}</span>
                      </>
                    )
                  }
                </div>
              </div>
            </div>
          </div>
        )
      }
      <div className="im-box im-box--white im-box--border-radius im-box--top-radius-0 flex-grow-1">
        <div className="mb-3">
          {
            machine?.report.images.length > 0
              ? (
                <Image
                  src={machine.report.images[0].main}
                  layout="responsive"
                  width="800"
                  height="800"
                  className="img-responsive"
                />
              )
              : (
                <Image
                  src="/image/machine-detail-slider-placeholder.jpg"
                  layout="responsive"
                  width="800"
                  height="800"
                  className="img-responsive"
                />
              )
          }
        </div>
        <div className="mb-3">
          <div className="fs-18 fw-900">{getObjectByLanguage(machine.title)}</div>
        </div>
        <div className="row mb-2">
          <div className="col-15 mb-2 mb-sm-0 col-sm-6">
            <div className="row flex-sm-column">
              <div className="col col-sm-15 order-2 order-sm-1">
                <span className="fs-14 fw-900 text-gray10 mb-1">{machine.serialNumber}</span>
              </div>
              <div className="col-6 col-sm-15 order-1 order-sm-2">
                <span className="fs-14">Seri No</span>
              </div>
            </div>
          </div>
          <div className="col-15 mb-2 mb-sm-0 col-sm-9">
            <div className="row flex-sm-column">
              <div className="col col-sm-15 order-2 order-sm-1">
                <span className="fs-14 fw-900 text-gray10 mb-1">
                  {`${machine?.region}, ${getObjectByLanguage(machine?.country.name)}`}
                </span>
              </div>
              <div className="col-6 col-sm-15 order-1 order-sm-2">
                <span className="fs-14">{t('locationDif')}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

MachineInformationSide.propTypes = {
  t: PropTypes.func,
  machine: PropTypes.object,
  timeLeft: PropTypes.object,
};

export default withTranslation('common')(MachineInformationSide);
